export default async function ({ app, store, redirect }) {
  if (await store.$auth.loggedIn === false) {
    const redirectTo = `/public${app.context.route.fullPath}`
    return redirect(redirectTo)
  }
}
